import api from '@pray/shared/utils/api';

const POLL_INTERVAL_MS = 5000;
// The server gives a download 10 minutes and expires its process at 15.
const MAX_WAIT_MS = 16 * 60 * 1000;

export const PRAY_RADIO_REHOSTING_STATUS = 'rehosting';

export type PrayRadioRehosting = {
  status: typeof PRAY_RADIO_REHOSTING_STATUS;
  process_id: string;
  content?: { id: string; title: string | null };
};

// A 202 from copy-from-content or Auto: the episode is hosted outside Pray and its audio is being copied to Pray.
export function asPrayRadioRehosting(body: unknown): PrayRadioRehosting | null {
  const data = (body as { data?: PrayRadioRehosting } | undefined)?.data;
  return data?.status === PRAY_RADIO_REHOSTING_STATUS && data.process_id ? data : null;
}

const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

/** Resolves once the audio copy has finished; throws with the server's reason when it fails or takes too long. */
export async function waitForPrayRadioAudioRehost({ artistId, processId }: { artistId: string; processId: string }) {
  const url = `/web/studio/artists/${artistId}/pray-radio-dailies/rehost-status`;
  const deadline = Date.now() + MAX_WAIT_MS;

  while (Date.now() < deadline) {
    await sleep(POLL_INTERVAL_MS);
    const response = await api.executeGetRequest<{ data?: { status: string; error: string | null } }>(url, {
      process_id: processId,
    });
    const status = response.data?.data;
    if (status?.status === 'completed') return;
    if (status?.status === 'failed') {
      throw new Error(status.error ?? "The episode's audio could not be copied to Pray.");
    }
  }

  throw new Error("Copying the episode's audio to Pray is taking too long. Try again in a few minutes.");
}
